import React from 'react';
import { Link } from 'react-router-dom';
import { List, Tag, Button, Card } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { GET_APPROVAL_ROUTE_TEMPLATES } from '../../../gql/approvalRoutes';

const listActions = ({ item }) => {
  return [
    <Link key="edit" to={`/system-setting/approval-routes/${item.id}`}>
      Edit
    </Link>,
    // <Button
    //   type="link"
    //   key="state"
    //   // loading={updateLoading}
    //   // onClick={() => {
    //   //   disableRole({
    //   //     variables: {
    //   //       disableRoleInput: {
    //   //         id: item.id,
    //   //         disabled: !item.disabled,
    //   //       },
    //   //     },
    //   //   });
    //   // }}
    // >
    //   {item.disabled ? 'Active' : 'Disable'}
    // </Button>,
  ];
};

const ApprovalRoutes = () => {
  const { data, loading } = useQuery(GET_APPROVAL_ROUTE_TEMPLATES, {
    variables: { state: 'ALL' },
  });
  return (
    <PageContainer
      loading={loading}
      header={{
        title: 'Approval Route Templates',
        extra: [
          <Button key="add" type="primary">
            <Link to="/system-setting/approval-routes/add">
              <PlusOutlined /> Add
            </Link>
          </Button>,
        ],
      }}
    >
      <Card bordered={false}>
        <List
          itemLayout="horizontal"
          dataSource={loading ? [] : data.approvalRouteTemplates}
          pagination={{ pageSize: 10 }}
          renderItem={(item) =>
            item.deleted ? (
              ''
            ) : (
              <List.Item actions={listActions({ item })}>
                <List.Item.Meta
                  title={`${item.name}`}
                  description={item.description}
                />
                {item.disabled ? (
                  <Tag>Disabled</Tag>
                ) : item.deleted ? (
                  <Tag color="red">Deleted</Tag>
                ) : (
                  <Tag color="green">Active</Tag>
                )}
              </List.Item>
            )
          }
        ></List>
      </Card>
    </PageContainer>
  );
};

export default ApprovalRoutes;
